export default {
  FormTabKey: {
    RepairAssetTitle: "Tài sản cần sửa chữa",
    MaintainAssetTitle: "Tài sản cần bảo dưỡng",
    CalendarMaintainRepairTitle: "Lịch bảo dưỡng, sửa chữa",
  },
  List: {
    title: "Cấp phát/Thu hồi",
    Search: "Tìm kiếm nhân viên theo tên, mã...",
    OrganizationUnit: "Phòng ban",
    Employee: "Nhân viên",
    JobPosition: "Vị trí",
    Allocation: "Cấp phát",
    Reduce: "Thu hồi",
  },
  Confirm: {
    Title: "Xác nhận tài sản hỏng",
  },
  Detail: {
    title: "Cấp phát theo nhân viên",
    TitleAsset: "Thông tin tài sản",
    TitleRepair: "Sửa chữa tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    RepairDate: "Ngày sửa chữa",
    Provider: "Nhà cung cấp dịch vụ",
    PurchaseDate: "Ngày mua",
    Warranty: "Hạn bảo hành",
    Date: "Ngày sử dụng",
    User: "Người sử dụng",
    Object: "Đối tượng sử dụng",
    Organization: "Đơn vị sử dụng",
    Representative: "Người đại diện",
    Location: "Vị trí hiện tại",
    BrokenDate: "Ngày đánh dấu hỏng",
    ReportBrokenDate: "Ngày báo hỏng",
    Description: "Mô tả tình trạng",
    Information: "Thông tin xác nhận",
    Specifications: "Quy cách tài sản",
    Cost: "Chi phí thực tế",
    MaintenanceTime: "Kỳ bảo dưỡng",
    MaintenanceBegin: "Lần bảo dưỡng gần nhất",
    OrgPrice: "Giá trị tài sản",
    RemainingAmount: "Giá trị còn lại",
    Status: "Tình trạng",
    AllocationDate: "Ngày đưa vào sử dụng",
    BrokenDate: "Ngày hỏng",
    BrokenStatus: "Mô tả tình trạng hỏng",
    Quantity: "Số lượng",
    QuantityRepair: "SL sửa chữa",
    QuantityRepairFull: "Số lượng sửa chữa",
    EmployeeName: "Nhân viên sử dụng",
  },
  Repair: {
    Title: "Sửa chữa/bảo hành tài sản",
    AssetInfo: "Thông tin tài sản",
    RepairInfo: "Thông tin sửa chữa/bảo hành tài sản",
    RepairDate: "Ngày sửa/bảo hành",
    RepairDateShort: "Ngày sửa chữa",
    Cost: "Chi phí dự kiến",
    RepairOrganization: "Tên đơn vị sửa chữa",
    RepairOrganizationShort: "Đơn vị sửa chữa",
    RepairContent: "Nội dung sửa chữa",
    ReUse: "Đưa tài sản sửa chữa vào sử dụng lại",
    ReUseInfo: "Thông tin đưa tài sản vào sử dụng",
    WarehouseDate: "Ngày đưa vào kho",
    ReUseDate: "Ngày đưa vào sử dụng lại",
    Employee: "Người thực hiện",
    FinishRepairDate: "Ngày sửa chữa xong",
    ValidateOccurenceDateQuantity: "Ngày đưa vào sử dụng phải lớn hơn hoặc bằng ngày mua",
    ValidateOccurenceDateCode: "Ngày sửa chữa phải lớn hơn hoặc bằng ngày ######",
    RepairCount: "Số lượng sửa chữa",
    RepairDetail: "Chi tiết tài sản sửa chữa",
  },
  Maintain: {
    Title: "Bảo dưỡng tài sản",
    MaintainInfo: "Thông tin bảo dưỡng",
    MaintainDate: "Ngày bảo dưỡng",
    Cost: "Chi phí dự kiến",
    MaintainOrganization: "Tên đơn vị bảo dưỡng",
    MaintainOrganizationShort: "Tên đơn vị",
    MaintainContent: "Nội dung bảo dưỡng",
    ReUse: "Đưa tài sản bảo dưỡng vào sử dụng lại",
    ReUseInfo: "Thông tin đưa tài sản vào sử dụng",
    WarehouseDate: "Ngày đưa vào kho",
    ReUseDate: "Ngày đưa vào sử dụng lại",
    Employee: "Người thực hiện",
    FinishMaintainDate: "Ngày bảo dưỡng xong",
    ValidateOccurenceDate: "Ngày bảo dưỡng phải lớn hơn hoặc bằng ngày mua.",
    ValidateMaintenanceBegin: "Ngày bảo dưỡng phải lớn hơn hoặc bằng lần bảo dưỡng gần nhất.",
    ValidateAllocationDate: "Ngày bảo dưỡng phải lớn hơn hoặc bằng ngày cấp phát.",
  },
  Validate: {
    ErrorRepair:
      "Tài sản quản lý theo mã phải thuộc loại: hỏng, đánh dấu hỏng, chưa sử dụng hoặc đang sử dụng",
    ErrorMaintain:
      "Tài sản quản lý theo mã phải thuộc loại: hỏng, đánh dấu hỏng, chưa sử dụng hoặc đang sử dụng",
    ErrorQuantityRepair: "Tài sản quản lý theo số lượng không hợp lệ",
    ErrorQuantityMaintain: "Tài sản quản lý theo số lượng không hợp lệ",
    ErrorQuantityRepairDetail: "Số lượng sửa chữa phải nằm trong khoảng từ 1 đến ##0##",
    QuantityNotValid:
      "Số lượng tài sản sửa chữa các dòng chi tiết không bằng tổng số lượng tài sản đem đi sửa chữa.",
  },
};
